module.exports = __webpack_public_path__ + "static/34th-eefd7bed119bbd20964e75c6c31c818b.png";